import { Page, View, Text, Link } from '@react-pdf/renderer';
import { styles } from './styles';
import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { SafeImage } from '../../components/SafeImage';
import { useTranslation } from 'react-i18next';
import { APP_HOST } from '@utils/apiHooks';
import { normalizeText, truncateText } from '../../../utils';

const CITATION_DESCRIOPTION_MAX_LENGTH = 875;

export interface CitationPageProps {
  event: PublicEventDetailsResponse;
  header: JSX.Element;
  footer: JSX.Element;
}

const CitationPage = ({ event, header, footer }: CitationPageProps) => {
  const { t } = useTranslation();

  const citation = event.website_content?.citations?.[0] || {};
  const personDetails: string = citation
    ? [
        truncateText(citation?.first_name || '', 30, false),
        truncateText(citation?.last_name || '', 30, false),
        truncateText(citation?.jobtitle || '', 30, false),
        truncateText(citation?.company || '', 30, false),
      ]
        .filter(Boolean)
        .join(', ')
    : '';

  return (
    <Page size="A4" orientation="portrait" style={styles.page}>
      {header}

      {personDetails ? (
        <View
          style={{
            ...styles.citationWrapper,
            backgroundColor: event?.design?.themeColor || 'black',
            color: event?.design?.headerFontColor || 'white',
          }}
        >
          <View style={styles.citationInnerWrapper}>
            <Text style={styles.citation}>
              “{truncateText(citation.citation, 200, true)}”
            </Text>
            <View style={styles.line} />
            <Text style={styles.personDetails}>{personDetails}</Text>
          </View>
        </View>
      ) : (
        <View style={{ height: 120 }}></View>
      )}

      <View style={styles.contentWrapper}>
        <View style={styles.leftColumn}>
          <Text style={styles.title}>
            {truncateText(normalizeText(event?.description), 175, true)}
          </Text>

          <View
            style={{
              ...styles.titleUnderline,
              borderColor: event?.design?.themeColor || 'black',
            }}
          />

          <Text style={styles.description}>
            {truncateText(
              normalizeText(event?.about),
              CITATION_DESCRIOPTION_MAX_LENGTH,
              true
            )}

            {(normalizeText(event?.about).length ?? 0) >
              CITATION_DESCRIOPTION_MAX_LENGTH && (
              <Link
                href={`${APP_HOST}/events/${event?.slug}#about`}
                style={{
                  color: event?.design?.themeColor || 'black',
                  textDecoration: 'none',
                }}
              >
                {' - '}
                {t('read-more')}
              </Link>
            )}
          </Text>
        </View>

        <View style={styles.rightColumn}>
          {/* TOP IMAGE */}
          <SafeImage
            style={styles.topImage}
            src={`https://media.we-conect.com/website/portfolios/${event?.portfolio?.slug}/event_guide_citation_1.jpg`}
          />

          {/* MIDDLE ROW */}
          <View style={styles.middleRow}>
            <SafeImage
              style={styles.middleImage}
              src={`https://media.we-conect.com/website/portfolios/${event?.portfolio?.slug}/event_guide_citation_2.jpg`}
            />
            <SafeImage
              style={styles.middleImage}
              src={`https://media.we-conect.com/website/portfolios/${event?.portfolio?.slug}/event_guide_citation_3.jpg`}
            />
          </View>

          {/* BOTTOM IMAGE */}
          <SafeImage
            style={styles.bottomImage}
            src={`https://media.we-conect.com/website/portfolios/${event?.portfolio?.slug}/event_guide_citation_4.jpg`}
          />
        </View>
      </View>

      {footer}
    </Page>
  );
};

export default CitationPage;
